export default __webpack_public_path__ + "static/media/expoindo-2.ff472c84.jpg";